import * as React from 'react';

import { ApButtonSecondary, ApIcon, ApMenu, ApMenuItem, colors } from '@alixpartners/ui-components';

import {
  HeaderDropdownLabelContainer,
  HeaderDropdownLabelText,
  CheckIcon,
  MenuLabel,
  NoDataWrapper,
  SearchWrapper,
  StyledSearch,
} from './HeaderDropdown.styles';

export const HeaderDropdown = ({
  options,
  selected,
  onChange,
}) => {
  const [search, setSearch] = React.useState('');
  const onSearchChange = (query) => {
    setSearch(query);
  };
  const onSearchClear = () => {
    setSearch('');
  };
  const filteredOptions = search
    ? options.filter(({ label }) =>
      label.toLowerCase().includes(search.toLowerCase())
    )
    : options;
  return (
    <ApMenu
      button={
        <ApButtonSecondary>
          <HeaderDropdownLabelContainer>
            <HeaderDropdownLabelText>{selected.label}</HeaderDropdownLabelText>
            <ApIcon
              iconName="caret"
              iconColor={colors.grey7}
            />
          </HeaderDropdownLabelContainer>
        </ApButtonSecondary>
      }
    >
      <SearchWrapper>
        <StyledSearch
          onChange={onSearchChange}
          onClear={onSearchClear}
          value={search}
        />
      </SearchWrapper>
      <div style={{ maxHeight: '420px', maxWidth: '300px', overflow: 'auto' }}>
      {filteredOptions.map((option) => (
        <ApMenuItem
          key={`${option.label}-${option.value}`}
          onClick={() => {
            onChange(option);
          }}
          icon={
            <CheckIcon
              iconName="outline_done"
              visible={selected.value === option.value}
            />
          }
        >
          <MenuLabel title={option.label}>{option.label}</MenuLabel>
        </ApMenuItem>
      ))}
      </div>
      
      {search && filteredOptions.length === 0 && (
        <NoDataWrapper>No results found</NoDataWrapper>
      )}
      
    </ApMenu>
  );
};

export default HeaderDropdown;
